<template>
  <app-dialer-main-popup
    :avatar="avatar"
    :agent="agent"
    :contact="contact"
    :identifier="identifier"
    :description="description"
    :members="members"
    :timestamp="timestamp"
    :session-id="sessionId"
    :is-connecting="isConnecting"
    :is-in-progress="isInProgress"
    :is-on-hold="isContactOnHold"
    :is-muted="isAgentMuted"
    :is-put-on-hold-action-loading="isPutOnHoldActionLoading"
    :is-hang-up-action-loading="isHangUpActionLoading"
    :is-info-active="isInfoActive"
    :is-keypad-active="isKeypadActive"
    :is-members-popup-active="isMembersPopupActive"
    :is-invite-popup-active="isInvitePopupActive"
    :is-transfer-popup-active="isTransferPopupActive"
    :has-keypad-button="hasKeypadButton"
    :has-invite-button="hasInviteButton"
    :has-transfer-button="hasTransferButton"
    :has-hold-button="hasHoldButton"
    :has-mute-button="hasMuteButton"
    :show-go-to-button="showGoToButton"
    @toggle-info="$emit('toggle-info')"
    @toggle-members-popup="$emit('toggle-members-popup')"
    @toggle-keypad="$emit('toggle-keypad')"
    @toggle-invite-popup="$emit('toggle-invite-popup')"
    @toggle-transfer-popup="$emit('toggle-transfer-popup')"
    @put-on-hold="onTogglePutOnHold"
    @mute-self="onToggleMuteSelf"
    @hang-up="onHangUp"
    @go-to-session="onGoToSession"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import AppDialerMainPopup from '../../components/popups/AppDialerMainPopup.vue';
import {
  useCommonProps,
  useDialerStore,
  useDialerActions,
  useConferenceMembersActions,
} from '../../composables';

export default defineComponent({
  name: 'AppDialerMainPopupContainer',
  components: {
    AppDialerMainPopup,
  },
  props: {
    isInfoActive: Boolean,
    isKeypadActive: Boolean,
    isMembersPopupActive: Boolean,
    isInvitePopupActive: Boolean,
    isTransferPopupActive: Boolean,
  },
  emits: [
    'toggle-info',
    'toggle-keypad',
    'toggle-members-popup',
    'toggle-invite-popup',
    'toggle-transfer-popup',
  ],
  setup() {
    const { avatar, activeSessionId, goToSession } = useCommonProps();
    const {
      identifier,
      sessionId,
      description,
      isInProgress,
      isContactOnHold,
      isAgentMuted,
      isPutOnHoldActionLoading,
      isHangUpActionLoading,
      agent,
      contact,
      members,
      timestamp,
      isConnecting,
      hasKeypadButton,
      hasInviteButton,
      hasTransferButton,
      hasHoldButton,
      hasMuteButton,
    } = useDialerStore();
    const {
      onTogglePutOnHold,
      onToggleMuteSelf,
      onHangUp,
    } = useDialerActions();
    const { getConferenceMembers } = useConferenceMembersActions();

    return {
      avatar,
      activeSessionId,
      agent,
      contact,
      identifier,
      sessionId,
      description,
      members,
      timestamp,
      isConnecting,
      isInProgress,
      isContactOnHold,
      isAgentMuted,
      isPutOnHoldActionLoading,
      isHangUpActionLoading,
      hasKeypadButton,
      hasInviteButton,
      hasTransferButton,
      hasHoldButton,
      hasMuteButton,
      getConferenceMembers,
      onTogglePutOnHold,
      onToggleMuteSelf,
      onHangUp,
      goToSession,
    };
  },
  computed: {
    showGoToButton() {
      return this.activeSessionId !== this.sessionId;
    },
  },
  mounted() {
    this.getConferenceMembers();
  },
  methods: {
    onGoToSession() {
      this.goToSession({ sessionId: this.sessionId });
    },
  },
});
</script>
